import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import ListaRoles from './ListaRoles';

import AuthProvider from '../../AuthProvider';
import ListaRolesContratantes from './ListaRolesContratantes';
import ListaContratantes from './ListaContratantes';
import ListaWebhookEscrita from './ListaWebhookEscrita';
import ListaWebhookLeitura from './ListaWebhookLeitura';
import QuantidadeErros from './QuantidadeErros';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Admin » Outros" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (containsRole(['admin'])) {
              children.push(
                QuantidadeErros,
                ListaRoles,
                ListaRolesContratantes,
                ListaContratantes,
                ListaWebhookEscrita,
                ListaWebhookLeitura
              );
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/OutrosAdmin.js